import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';
import { CURRENCY } from '../libs/utils/Const';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};


const renderTableBody = (headers, data, action, checkbox) => {
    let body= "";

    body = data.map((register, index) => {

        let fecha = new Date(register.TaxDate);
        fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
        fecha =  moment(fecha).format('DD-MM-YYYY');

        return (
            <tr key={index}>
                <td style={{textAlign:"center", width:100}}>
                    <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" checked={!!checkbox.data.get(index)} disabled={ register.selected || false}
                           onChange={() => checkbox.selectOne(index)}/>
                </td>
                <td style={{textAlign:"center"}}>{register.SeriesName}</td>
                <td style={{textAlign:"center"}}>{register.DocNum || ""}</td>
                <td style={{textAlign:"center"}}>{fecha}</td>
                <td style={{textAlign:"center"}}>{register.CardCode || ''}</td>
                <td style={{textAlign:"center"}}>{register.CardName || ''}</td>
                <td style={{textAlign:"left"}}>{register.Comments || ""}</td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">
                <input type="checkbox" style={{minWidth: '100%'}}
                       onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[0].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[1].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[2].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[3].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[4].title}</td>
            <td className="sticky-header table-header-yellow " style={{textAlign:"center"}}>{headers[5].title}</td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderSelectOfModal = (headers, data, action,checkbox) => {

    return renderTable(headers, data, action, checkbox);

}

